import { fork } from "redux-saga/effects";
import { authSaga } from "./authSaga";
import { userSaga } from "./userSaga";
import { leavesSaga } from "./leavesSaga";
import { holidaySaga } from "./holidaySaga";
import { salarySettingSaga } from "./salarySettingsSaga";
import { salaryListSaga } from "./salaryListSaga";
import { assetsSaga } from "./assetsSaga";
import { assignSaga } from "./assignSaga";
import { balanceSaga } from "./balanceSaga";
import { documentSaga } from "./documentSaga";
import { projectSaga } from "./projectSaga";
import { timeEntrySaga } from "./timeEntrySaga";
import { hrSaga } from "./hrSaga";
import { financialSaga } from "./financialSaga";

export default function* rootSaga() {
  yield fork(authSaga);
  yield fork(userSaga);
  yield fork(leavesSaga);
  yield fork(holidaySaga);
  yield fork(salarySettingSaga);
  yield fork(salaryListSaga);
  yield fork(assetsSaga);
  yield fork(assignSaga);
  yield fork(balanceSaga);
  yield fork(documentSaga);
  yield fork(projectSaga);
  yield fork(timeEntrySaga);
  yield fork(hrSaga);
  yield fork(financialSaga);
}
